import PAButton, { BUTTON_SIZE, BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { memo } from "react";
import openLiveChat from "util/chat-widget/open-live-chat";
import { getChatOnlineTime } from "util/date-helper";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import styles from "./help-desk.module.scss";

function HelpDesk() {
  const online = getChatOnlineTime();
  const { t } = useTranslation("product");
  const avatarImages = [
    "/cms/pubicImages/images/mechanic-avatar-1.webp",
    "/cms/pubicImages/images/mechanic-avatar-2.webp",
    "/cms/pubicImages/images/mechanic-avatar-3.webp",
    "/cms/pubicImages/images/mechanic-avatar-4.webp",
    "/cms/pubicImages/images/mechanic-avatar-5.webp",
    "/cms/pubicImages/images/mechanic-avatar-6.webp",
  ];
  const randomImageIndex = Math.floor(Math.random() * avatarImages.length);
  return (
    <div className={`d-flex flex-wrap ${styles.help_desk_wrapper}`}>
      <PAImage
        className={`${styles.img_mech}`}
        src={`${getRelativeImagePath(avatarImages[randomImageIndex])}`}
        alt="Feel free to reach out with your questions and inquiries."
        title="Feel free to reach out with your questions and inquiries."
        width={60}
        height={60}
      />
      <div className={styles.help_desk_content}>
        <PAText
          component="p"
          fontSize={FONT_SIZE[2]}
          bold
          className={`${styles.help_desk_color} ${styles.question_title}`}
        >
          {t("Have any questions ?")}
        </PAText>
        <PAText
          fontSize={FONT_SIZE[1]}
          className={`${styles.help_desk_color} ${styles.help_text_span}`}
        >
          {t("We are here to help.")}
        </PAText>
        <PAButton className={styles.live_chat_btn} buttonType={BUTTON_TYPE.NORMAL} size={BUTTON_SIZE.STANDARD} onClick={() => openLiveChat()}>
          {online ? t("Live Chat") : t("Talk to us")}
        </PAButton>
      </div>
      {/* <DynamicPhoneCallToAction /> */}
      <HorizontalSeparator className="m-t-0 m-b-0" />
    </div>
  );
}

export default memo(HelpDesk);
